export default "__VITE_ASSET__5f8010a5__"